






















































import { Component, Vue } from "vue-property-decorator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import { i18n } from "@/resources/locales";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
@Component({
  name: "spotify-modal-component",
})
export default class SpotifyModalComponent extends mixins(NotificationEvent) {
  myplayListId = "";
  addPlayList = false;
  loading = false;
  mounted() {}
  get active() {
    return this.$store.getters["SystemStore/getOpenSpotifyModal"];
  }
  get space(): SpaceInterface {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return space;
  }
  openSpotifyWeb() {
    if (this.space && this.space.playlist)
      window.open(
        "https://open.spotify.com/playlist/" + this.space.playlist.id,
        "_blank"
      );
  }
  openSpotifyApp() {
    window.open("spotify:playlist:" + this.space.playlist.id, "_blank");
  }
  async addPlayListId() {
    this.loading = true;
    let parts = this.myplayListId.split("playlist/");
    let result = parts[1];
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    await this.$store.dispatch("UserStore/updateUserAction", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        playlist: result,
      },
      callback: async () => {
        this.loading = false;
        this.myplayListId = "";
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.userUpdate")
        );
      },
      callbackError(error) {
        this.loading = false;
        console.log("TTT addPlayListId KO ", error);
      },
    });
  }
  openAddPlayList() {
    this.$store.dispatch("FloatMenuStore/setOpenProfileSocialAction", true);
    this.$store.dispatch("FloatMenuStore/setOpenProfileAction", true);
  }
  close() {
    this.$store.dispatch("SystemStore/setOpenSpotifyModalAction", false);
    this.addPlayList = false;
  }
}
